import { Icon } from '@/components/Icon';
import { componentClassName } from '@/styles/SoMe';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';
import { mergeProps } from '@/utils/mergeProps';
import { SocialMediaType } from '.';

export interface SoMeProps extends ComponentProps<'span'> {
  name?: SocialMediaType;
  colors?: ClassNameProp<'plain' | 'filled' | 'border'>;
}

const SoMeComponent: Component<SoMeProps> = ({ children, name, theme, colors, size, variant, ...props }) => {
  const classNameProps = { colors, size, variant };
  const classNameDefaults = { colors: 'filled' };

  const className = cn(componentClassName('', classNameProps, { defaults: classNameDefaults, theme }));

  return (
    <span {...mergeProps({ className }, props)}>
      <Icon name={name} />
      {children}
    </span>
  );
};

export const SoMe = SoMeComponent;
